let radioListenersInitialized = false;

function bindCartDropdownEvents() {
  const contentContainer = document.getElementById("cart-dropdown-content");
  const continueButton = document.getElementById("cart-dropdown-continue");
  const shippingContainer = document.getElementById("cart-dropdown-shipping");
  const deliveryNotesContainer = document.getElementById("cart-dropdown-delivery-notes");
  const nextButton = document.getElementById("cart-dropdown-next");
  const dropdownToggles = document.getElementById("cart-dropdown-toggle");
  const shippingForm = document.getElementById("cart-dropdown-shipping");
  const error = document.querySelector(".cart-delivery__error");

  // Get button text from data attributes
  const continueText = shippingForm ? shippingForm.dataset.continueText : "Continue";
  const checkoutText = shippingForm ? shippingForm.dataset.checkoutText : "Checkout";

  // Initialize: show content, hide others
  contentContainer.classList.remove("hidden-content");
  shippingContainer.classList.add("hidden-content");
  if (deliveryNotesContainer) {
    deliveryNotesContainer.classList.add("hidden-content");
  }

  // Function to update button text based on selected option
  function updateNextButtonText() {
    if (!nextButton) return;

    const pickupRadio = document.getElementById("pickup_radio");
    const deliveryRadio = document.getElementById("delivery_radio");
    const isPickup = pickupRadio && pickupRadio.classList.contains("active");
    const isDelivery = deliveryRadio && deliveryRadio.classList.contains("active");

    // Check if delivery notes are showing
    const deliveryNotesVisible = deliveryNotesContainer && !deliveryNotesContainer.classList.contains("hidden-content");

    if (deliveryNotesVisible) {
      nextButton.textContent = checkoutText;
      //nextButton.setAttribute("disabled", "false");
      //nextButton.disabled = false;
    } else if (isPickup) {
      nextButton.textContent = checkoutText;
      //nextButton.setAttribute("disabled", "false");
      //nextButton.disabled = false;
    } else if (isDelivery) {
      nextButton.textContent = continueText;
      //nextButton.setAttribute("disabled", "true");
      //nextButton.disabled = true;
    }
  }

  // Step 1: Continue button -> Shipping selection
  if (continueButton) {
    continueButton.addEventListener("click", () => {
      contentContainer.classList.add("hidden-content");
      shippingContainer.classList.remove("hidden-content");
      if (typeof window.zapietCustom === "function") {
        window.zapietCustom();
      }

     /* if (nextButton.dataset.clicked !== "true") {
        nextButton.setAttribute("disabled", "true");
      }
      nextButton.dataset.clicked = "true";*/

      // Set initial button text when shipping container opens
      setTimeout(() => {
        updateNextButtonText();
        setupRadioListeners();
      }, 100);
    });
  }

  // Setup event listeners for radio buttons (guard against duplicates)
  function setupRadioListeners() {
    if (!radioListenersInitialized) {
      radioListenersInitialized = true;
      document.addEventListener("click", (event) => {
        if (event.target.id === "pickup_radio" || event.target.id === "delivery_radio") {
          handleRadioChange();
        }
      });
    }
    const pickupRadio = document.getElementById("pickup_radio");
    const deliveryRadio = document.getElementById("delivery_radio");

    // Observer to watch for class changes on radio buttons (in case they're changed by Zapiet)
    const radios = [pickupRadio, deliveryRadio].filter(Boolean);
    radios.forEach(radio => {
      const observer = new MutationObserver(handleRadioChange);
      observer.observe(radio, { attributes: true, attributeFilter: ["class"] });
    });
  }

  // Handle radio button changes
  function handleRadioChange() {
    const pickupRadio = document.getElementById("pickup_radio");
    const isPickup = pickupRadio && pickupRadio.classList.contains("active");

    // Hide delivery notes when pickup is selected or when switching between options
    if (isPickup && deliveryNotesContainer && !deliveryNotesContainer.classList.contains("hidden-content")) {
      deliveryNotesContainer.classList.add("hidden-content");
      toggleDeliveryContainer(false);
    }
    error.classList.remove("cart-delivery__error--active");
    updateNextButtonText();
  }

  // Toggle delivery container visibility
  function toggleDeliveryContainer(hideDelivery) {
    const storePickupContainer = document.querySelector(".storePickupApp__container");
    if (storePickupContainer) {
      if (hideDelivery) {
        storePickupContainer.classList.add("hide-delivery");
      } else {
        storePickupContainer.classList.remove("hide-delivery");
      }
    }
  }

  // Step 2: Next button -> Check if pickup or delivery
  if (nextButton) {
    nextButton.addEventListener("click", (e) => {
      const pickupRadio = document.getElementById("pickup_radio");
      const isPickup = pickupRadio && pickupRadio.classList.contains("active");
      const deliveryNotesVisible = deliveryNotesContainer && !deliveryNotesContainer.classList.contains("hidden-content");

      if (nextButton.dataset.clicked !== "true") {
        //nextButton.setAttribute("disabled", "true");
      }
      //nextButton.dataset.clicked = "true";

      if (deliveryNotesVisible) {
        // If delivery notes are showing, submit the form
        if (shippingForm) {
          shippingForm.submit();
        }
      } else if (isPickup) {
        // If pickup is selected, submit the form directly
        if (shippingForm) {
          shippingForm.submit();
        }
      } else {
        // If delivery is selected, show delivery notes

        let datePicker = document.querySelector("#deliveryDatePicker");
        if (!datePicker) {
          let postcodeField = document.querySelector("input#deliveryGeoSearchField");
          let error = document.querySelector(".cart-delivery__error");
          if (postcodeField.value.length > 0) {
            let postcodeButton = document.querySelector(".snize-exclude-input .searchIcon");
            if (postcodeButton) {
              postcodeButton.click();
              error.classList.remove("cart-delivery__error--active");
            }
          } else {
            if (error) {
              error.innerText = "Please enter your postcode to proceed to checkout.";
              error.classList.add("cart-delivery__error--active");
              e.preventDefault();
              e.stopPropagation();
              return;
            }
          }
        } else {
          let datePickerInput = document.querySelector("#Zapiet-InputCalendar__delivery");
          if (!!datePicker && datePickerInput.value === "") {
            let error = document.querySelector(".cart-delivery__error");
            if (error) {
              error.classList.add("cart-delivery__error--active");
              error.innerText = "Please select a delivery date to proceed to checkout.";
              e.preventDefault();
              e.stopPropagation();
              return;
            }
          } else if (deliveryNotesContainer) {
            deliveryNotesContainer.classList.remove("hidden-content");
            toggleDeliveryContainer(true);
            updateNextButtonText();
          }
        }
      }
    });
  }


  // Reset flow when closing the cart
  if (dropdownToggles) {
    dropdownToggles.addEventListener("click", () => {
      contentContainer.classList.remove("hidden-content");
      shippingContainer.classList.add("hidden-content");
      if (deliveryNotesContainer) {
        deliveryNotesContainer.classList.add("hidden-content");
      }

      // Reset delivery container visibility
      toggleDeliveryContainer(false);

      // Clear delivery notes
      const deliveryNotesTextarea = document.getElementById("delivery-notes-textarea");
      if (deliveryNotesTextarea) {
        deliveryNotesTextarea.value = "";
      }

      // Clear all inputs in all checkout method containers (including delivery)
      const deliveryInputs = document.querySelectorAll(
        "#storePickupApp .checkoutMethodContainer input",
      );
      deliveryInputs.forEach((input) => {
        if (input.type === "checkbox" || input.type === "radio") {
          input.checked = false;
        } else {
          input.value = "";
        }
      });

      // Programmatically select the delivery tab by clicking its radio button
      const deliveryRadio = document.getElementById("delivery_radio");
      if (deliveryRadio) {
        deliveryRadio.click();
      }

      // If present, trigger the delivery geo search button to reset delivery address search
      const deliveryGeoSearchButton = document.querySelector(
        "input#deliveryGeoSearchField + .button.snize-exclude-input",
      );
      if (deliveryGeoSearchButton) {
        deliveryGeoSearchButton.click();
      }

    });
  }
/*
  setInterval(() => {
    let checkoutEnabled = Zapiet.Widget.checkoutEnabled();
    let datePicker = document.querySelector("#deliveryDatePicker");
    if (checkoutEnabled && !!datePicker) {
      nextButton.setAttribute("disabled", "false");
      nextButton.disabled = false;
    } else if (nextButton.dataset.clicked === "true" && !!datePicker) {
      nextButton.setAttribute("disabled", "true");
      nextButton.disabled = true;
    }
  }, 500)*/

}

document.addEventListener("DOMContentLoaded", bindCartDropdownEvents);
document.addEventListener("cart:refreshed", bindCartDropdownEvents);
